import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// import { ourTeam } from "../../common";
// core components
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import AboutUsBanner from "../../components/AboutUs/AboutUsBanner";
import ClientCounter from "../../components/AboutUs/ClientCounter";
import AboutContent from "../../components/AboutUs/AboutContent";
// import OurTeam from "../../components/AboutUs/OurTeam";
import WhyHow from "../../components/AboutUs/WhyHow";
import ScrumMethodology from "../../components/AboutUs/ScrumMethodology";
import SpecializedTechnologies from "../../components/SpecialisedinTechnologies/SpecialisedinTechnologies";
import YourIdea from "../../components/AboutUs/YourIdea";
import CustomerReviews from "../../components/CustomerReviews/CustomerReviews";
import OurLatestBlogs from "../../components/OurLatestBlogs/OurLatestBlogs";
import ContactUsComponent from "../../components/ContactUsComponent/ContactUsComponent";
import FrequentlyAskedQuestions from "../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions";
import { getIPGeoLocation } from "../../common/GeneralUtils";
import axios from "axios";
import Toasts from "../../components/Toasts/Toasts";

// import Loadable from "../../components/Loadable"


// const Header = Loadable(
//     lazy(() => import('../../components/header/header'))
// )
// const Footer = Loadable(
//     lazy(() => import('../../components/footer/footer'))
// )
// const AboutUsBanner = Loadable(
//     lazy(() => import('../../components/AboutUs/AboutUsBanner'))
// )
// const ClientCounter = Loadable(
//     lazy(() => import('../../components/AboutUs/ClientCounter'))
// )
// const AboutContent = Loadable(
//     lazy(() => import('../../components/AboutUs/AboutContent'))
// )
// const OurTeam = Loadable(
//     lazy(() => import('../../components/AboutUs/OurTeam'))
// )
// const WhyHow = Loadable(
//     lazy(() => import('../../components/AboutUs/WhyHow'))
// )
// const ScrumMethodology = Loadable(
//     lazy(() => import('../../components/AboutUs/ScrumMethodology'))
// )
// const SpecializedTechnologies = Loadable(
//     lazy(() => import('../../components/SpecialisedinTechnologies/SpecialisedinTechnologies'))
// )
// const YourIdea = Loadable(
//     lazy(() => import('../../components/AboutUs/YourIdea'))
// )
// const CustomerReviews = Loadable(
//     lazy(() => import('../../components/CustomerReviews/CustomerReviews'))
// )
// const OurLatestBlogs = Loadable(
//     lazy(() => import('../../components/OurLatestBlogs/OurLatestBlogs'))
// )
// const ContactUsComponent = Loadable(
//     lazy(() => import('../../components/ContactUsComponent/ContactUsComponent'))
// )
// const FrequentlyAskedQuestions = Loadable(
//     lazy(() => import('../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions'))
// )

const AboutScreen = () => {
    const [toasts, setToasts] = useState(null)
    const [FrequentlyAskedQuestionsData, setData] = useState({});
    const [aboutPageData, setAboutPageData] = useState({});
    // const [ourTeam, setOurTeam] = useState({});
    const [clientCounterData, setClientCounterData] = useState([]);

    const getAllClientCounterData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/clientCounterData.json');
            setClientCounterData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }
    const getAllFrequentlyAskedQuestionsData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/frequentlyAskedQuestionsData.json');
            setData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }
    const getAllAboutPageData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/aboutPageData.json');
            setAboutPageData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }
    // const getAllOurTeamData = async () => {
    //     try {
    //         const res = await axios.get('/staticDataFiles/ourTeam.json');
    //         setOurTeam(res.data);
    //     } catch (err) {
    //         console.error('Error fetching blogs:', err);
    //     }
    // }


    useEffect(() => {
        getIPGeoLocation()
        getAllAboutPageData()
        getAllFrequentlyAskedQuestionsData()
        getAllClientCounterData()
        // getAllOurTeamData()
    }, [])
    return (
        <div id="main-wrapper">
            <Header />
            <div className="page-wrapper about-page-wrapper">
                <div className="container-fluid">
                    <div className="page-content-top">
                        <AboutUsBanner bannerImg={aboutPageData?.bannerImg} data={aboutPageData?.headerData} />
                        <ClientCounter data={clientCounterData} />
                        <AboutContent data={aboutPageData?.aboutText} />
                        {/* <OurTeam data={ourTeam} /> */}
                        <WhyHow />
                        <ScrumMethodology />
                        <SpecializedTechnologies data={aboutPageData?.techIndustry} />
                        <YourIdea data={aboutPageData?.yourIdea} />
                        <CustomerReviews />
                        <OurLatestBlogs />
                        <div className="home-contact-page">
                            <ContactUsComponent setToasts={setToasts} />
                        </div>
                        <FrequentlyAskedQuestions faqData={FrequentlyAskedQuestionsData} />
                    </div>
                </div>
            </div>
            <Footer />
            {toasts && <Toasts toastsList={toasts} />}
        </div>
    );
}

AboutScreen.propTypes = {
    classes: PropTypes.object
};

export default AboutScreen;
